var _a;
import { poiTypes } from "@lonelyplanet/dotcom-routing/dist/details/constants";
var keys = {
    drinking_nightlife: "drinking_nightlife",
    eating: "eating",
    sleeping: "sleeping",
};
var types = (_a = {},
    _a[keys.drinking_nightlife] = {
        Brewery: "Brewery",
        Cafe: "CafeOrCoffeeShop",
        Club: "NightClub",
        Coffee: "CafeOrCoffeeShop",
        Distillery: "Distillery",
        Juice: "FoodEstablishment",
        "Juice Bar": "FoodEstablishment",
        Karaoke: "EntertainmentBusiness",
        Microbrewery: "Brewery",
        Teahouse: "CafeOrCoffeeShop",
        Vineyard: "Winery",
        Winery: "Winery",
    },
    _a[keys.eating] = {
        Bakery: "Bakery",
        Cafe: "CafeOrCoffeeShop",
        "Fast Food": "FastFoodRestaurant",
        "Ice Cream": "IceCreamShop",
        Market: "GroceryStore",
        Pastries: "Bakery",
        Patisserie: "Bakery",
        Supermarket: "GroceryStore",
    },
    _a[keys.sleeping] = {
        "2 star hotel": "Hotel",
        "3 star hotel": "Hotel",
        "4 star hotel": "Hotel",
        "5 star hotel": "Hotel",
        apartment: "Apartment",
        "b&b": "BedAndBreakfast",
        "bed and breakfast": "BedAndBreakfast",
        "boutique hotel": "Hotel",
        campground: "Campground",
        "historic hotel": "Hotel",
        hostel: "Hostel",
        hotel: "Hotel",
        motel: "Motel",
        residence: "Residence",
        resort: "Resort",
    },
    _a);
export var schemaType = function (type, subtypes) {
    var typeOfPoi = types[type];
    if (typeof typeOfPoi === "undefined") {
        return "";
    }
    if (typeOfPoi && typeof typeOfPoi[subtypes[0]] === "undefined") {
        return poiTypes[type].schemaType;
    }
    return typeOfPoi[subtypes[0]];
};



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/utils/schema/schemaType.ts
// module id = qdOX
// module chunks = 2